var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTruckLog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon / vehicle (no photo)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-/-vehicle-(no-photo)",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    strokeWidth: 0.8,
    fill: "#D8D8D8",
    x: 0.4,
    y: 0.4,
    width: 31.2,
    height: 31.2,
    rx: 1.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "graph/truck_black",
    transform: "translate(3.200000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph/truck_grey"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 4,
    cx: 18.5405699,
    cy: 13.4193548,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-7",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 4,
    cx: 4.13852007,
    cy: 13.4193548,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-5",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 4,
    cx: 23.8378756,
    cy: 13.4193548,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4877252,10.8387097 L21.8908537,10.8387097 C21.7749829,10.9091783 21.6585839,11.0051727 21.5416565,11.1266928 C21.4247292,11.2482129 21.3072735,11.3952587 21.1892895,11.5678303 C21.0734187,11.3952587 20.9570197,11.2482129 20.8400923,11.1266928 C20.723165,11.0051727 20.6057093,10.9091783 20.4877252,10.8387097 Z",
    id: "Path-3",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5675907,0.172043011 C14.6010776,0.0573476703 14.6562579,0 14.7331315,0 C14.810005,0 14.8651853,0.0573476703 14.8986723,0.172043011 L15.0642131,0.516129032 L15.0642131,4.68590702 C15.0642131,4.87605076 15.1568746,5.05426502 15.3125243,5.16347957 L15.3125243,5.16347957 C15.4681739,5.27269411 15.5608355,5.45090837 15.5608355,5.64105211 L15.5608355,9.80645161 L15.2487923,10.1505376 L14.7331315,10.1505376 L14.2115344,10.1505376 L13.9054274,9.80645161 L13.9054274,5.66585877 C13.9054274,5.47152897 13.997552,5.28870462 14.1537386,5.17307674 L14.1537386,5.17307674 C14.3099253,5.05744886 14.4020498,4.8746245 14.4020498,4.68029471 L14.4020498,0.516129032 L14.5675907,0.172043011 Z",
    id: "Rectangle",
    fillOpacity: 0.87,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9594689,4.67804015 C6.0756896,4.42673023 6.2412304,4.30107527 6.45609131,4.30107527 C7.00789399,4.30107527 7.44933613,4.30107527 7.78041773,4.30107527 C8.08758079,2.30547973 9.41231335,1.04383098 11.7546154,0.516129032 L13.7398866,0.516129032 L13.7398866,10.8387097 L16.0574579,10.8387097 L16.0574579,11.4127618 C15.6424727,11.9666347 15.3952947,12.6629952 15.3952947,13.4193548 L7.28379533,13.4193548 C7.28379533,11.6140369 5.87560763,10.1505376 4.13852007,10.1505376 C2.40143251,10.1505376 0.993244817,11.6140369 0.993244817,13.4193548 L-5.68434189e-14,13.4193548 L-5.68434189e-14,8.39045392 C0.114602655,8.2647836 0.29790641,8.16105154 0.549911263,8.07925773 L5.9594689,7.74193548 L5.9594689,4.67804015 Z M7.28829878,4.98924731 C6.92010895,4.98924731 6.62163211,5.28772415 6.62163211,5.65591398 L6.62163211,7.07526882 C6.62163211,7.44345865 6.92010895,7.74193548 7.28829878,7.74193548 L8.60361829,7.74193548 C8.97180813,7.74193548 9.27028496,7.44345865 9.27028496,7.07526882 L9.27028496,5.65591398 C9.27028496,5.28772415 8.97180813,4.98924731 8.60361829,4.98924731 L7.28829878,4.98924731 Z",
    id: "Combined-Shape",
    fillOpacity: 0.87,
    fill: "#000000"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckLog);
export default __webpack_public_path__ + "static/media/truck_log.cf29697145240559b0b553e6fc79a69c.svg";
export { ForwardRef as ReactComponent };